import { API } from "../../../api/constants"
import { sessionCheckClient } from "../../../auth/AuthenticatedAxios"

// öffentliche Endpunkte (auth-contract.md „Passwort-Endpunkte“); Client ohne 401-Interceptor, Fehler zeigt die Seite selbst an
export const postPasswordForgot = (email: string) => sessionCheckClient.post(API + "/auth/password/forgot", { email }).then((res) => res.data)

export const postPasswordReset = (token: string, newPassword: string) => sessionCheckClient.post(API + "/auth/password/reset", { token, newPassword }).then((res) => res.data)
